import type { PlaygroundDataProvider } from './provider-types'

let current: PlaygroundDataProvider | null = null

export function setPlaygroundDataProvider(
  provider: PlaygroundDataProvider,
): void {
  current = provider
}

export function getPlaygroundDataProvider(): PlaygroundDataProvider {
  if (!current) {
    throw new Error(
      'No PlaygroundDataProvider installed. Call setPlaygroundDataProvider() ' +
        'at app startup (web installs backendPlaygroundProvider; desktop ' +
        'installs its local provider).',
    )
  }
  return current
}
